import http from '@/utils/http';

/**
 * 全量商机交接-分页查询-tr
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityFull/pageList',
        method: 'post',
        data
    });
};

/**
 * 全量商机交接-修改承接人-tr
 */
export function updateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityFull/update',
        method: 'post',
        data
    });
};

/**
 * 全量商机交接-批量保存/修改承接人-tr
 */
export function batchUpdateAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityFull/batchUpsert',
        method: 'post',
        data
    });
};

/**
 * 导入-cyj
 */
export function importAssignee(data) {
    return http({
        url: '/api-lcrm/asset/transfer/opportunityFull/importOpportunityFull',
        method: 'post',
        data
    });
};
